<template>
  <div class="subinfo">
    <div class="mian">
      <div style="height: 6rem;"></div>
      <div class="mode1">
        <div class="mode1-1">
          <div>姓名：<input v-model="username" class="input1" /></div>
          <div>
            性别：<span @click="chooseSex" class="input2">{{ usersex }}</span>
          </div>
        </div>
        <div class="mode1-1">
          <div>
            年龄：<input
              v-model="userage"
              class="input2"
              type="tel"
              maxlength="4"
            />
          </div>
          <div>
            电话：<input
              v-model="userphone"
              class="input1"
              type="tel"
              maxlength="11"
            />
          </div>
        </div>
      </div>
      <div class="mode2">
        <div class="mode2_title">您的症状为：</div>
        <textarea v-model="contentText"></textarea>
      </div>
      <div class="mode3">
        <div class="mode2_title">您的治疗方案为：</div>
        <div class="mode3_ul">
          <div class="li" v-for="(item, index) in contentList" :key="index">
            {{ item.content }}
          </div>
        </div>
        <div class="allMoney">
          合计价格为：<span>{{ money }}元</span>
        </div>
      </div>
      <div @click="yesSub" class="yesSub" v-if="subBtn">确认提交</div>
    </div>
    <!-- 性别 -->
    <div class="dialogSex" v-if="chooseSexBox">
      <van-picker
        class="chooseSexBox"
        show-toolbar
        title="性别"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </div>
  </div>
</template>

<script>
import { Toast, Picker } from "vant";
import { getAddConsultation } from "@api/public";
import { getInforMation } from "@api/lcapi";
import cookie from "@utils/store/cookie";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";
let vm = null;
export default {
  name: "mianzheng_subinfo",
  components: {
    [Picker.name]: Picker,
  },
  props: {},
  data: function() {
    return {
      subBtn: true,
      username: "",
      usersex: "女",
      userage: 1,
      userphone: "",
      contentText: "",
      chooseSexBox: false,
      columns: ["女", "男"],
      contentList: [],
      money: 0,
    };
  },
  created() {
    vm = this;
    console.log("内容：", cookie.get("saveData"));
    vm.contentList = cookie.get("saveData");
    if (!vm.contentList) {
      return Toast("请务必先选择方案后再提交");
    } else {
      for (var i = 0; i < vm.contentList.length; i++) {
        this.money = this.money + vm.contentList[i].money;
      }
    }
  },
  watch: {},
  mounted: function() {
    getInforMation({ secret_key: cookie.get("secret_key") }).then((res) => {
      this.username = res.data.name;
      this.userage = res.data.age;
      this.userphone = res.data.phone;
    });
  },
  computed: {},
  methods: {
    // 选择性别
    chooseSex() {
      this.chooseSexBox = true;
    },
    onConfirm(value) {
      this.usersex = `${value}`;
      this.chooseSexBox = false;
    },
    onCancel() {
      this.chooseSexBox = false;
    },

    // else if (
    //      !/^(([0-9]|[1-9][1-9]|1[0-7][0-9])(\\.[0-9]+)?|180)$/.test(this.userage)
    //    )
    yesSub() {
      // var regAge = /^(([0-9]|[1-9][1-9]|1[0-7][0-9])(\\.[0-9]+)?|180)$/;
      console.log("this.userage:", this.userage);
      console.log("this.userage_1:", typeof this.userage);
      if (this.username.trim().length < 1) {
        return Toast("请务必输入用户姓名！");
      } else if (this.userage < 1) {
        return Toast("请务必正确输入用户年龄！");
      } else if (!/^1[3456789]\d{9}$/.test(this.userphone)) {
        return Toast("请务必正确输入手机号！");
      } else if (this.contentText.trim().length < 1) {
        return Toast("请务必输入您的症状！");
      } else if (!cookie.get("saveData") || cookie.get("saveData").length < 1) {
        return Toast("请务必选择方案后再提交！");
      }
      var data = {
        user_name: this.username,
        sex: this.usersex == "女" ? 2 : 1,
        age: this.userage,
        phone: this.userphone,
        brand_key: cookie.get("secret_key"),
        content: JSON.stringify(cookie.get("saveData")),
        symptoms: this.contentText,
        total_price: this.money.toFixed(2),
        pid: cookie.get("pid"),
      };
      console.log(data);
      getAddConsultation(data)
        .then((res) => {
          Toast(res.msg);
          this.subInfoDialog = false;
          cookie.remove("saveData");
          this.subBtn = false;
          Toast("提交成功！");
        })
        .catch((err) => {
          Toast("提交失败！");
        });
    },
  },
};
</script>

<style>
body,
html {
  background-color: #490a94 !important;
}
.subinfo.router {
  background-image: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/bg_mony.png);
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 100%;
}
.mode1,
.mode2,
.mode3 {
  width: 94%;
  background: #a482c1;
  margin: 0.2rem auto 0;
  padding: 0.2rem 0.15rem;
  border-radius: 0.16rem;
}
.mode1-1 {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  color: #480483;
  font-size: 0.32rem;
  padding: 0.1rem 0;
}
.mode1-1 > div {
  display: flex;
  align-items: center;
}
.mode1-1 > div:nth-of-type(1) {
  margin-right: 0.15rem;
}
.mode1-1 input,
.mode1-1 span {
  background-color: #d4c3e1;
  display: block;
  border: 0;
  border-radius: 0.35rem;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
}
.input1 {
  width: 3rem;
}
.input2 {
  width: 1.5rem;
}
.mode2_title {
  color: #480483;
  font-size: 0.34rem;
  margin-bottom: 0.2rem;
}
textarea {
  width: 100%;
  height: 2.4rem;
  border-radius: 0.2rem;
  background-color: #d4c3e1;
  padding: 0.15rem;
}
.mode3_ul {
  width: 100%;
  margin: 0.2rem auto 0;
}
.mode3_ul .li {
  color: #480483;
  font-size: 0.25rem;
  border-bottom: 0.02rem solid #480483;
  padding: 0.1rem 0;
}
.allMoney {
  text-align: right;
  font-size: 0.28rem;
  color: #480483;
  margin-top: 0.4rem;
}
.dialogSex {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.7);
}
.chooseSexBox {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.yesSub {
  width: 90%;
  line-height: 0.8rem;
  background: #d4c3e1;
  text-align: center;
  border-radius: 0.16rem;
  margin: 1rem auto;
  font-size: 0.32rem;
  color: #480483;
}
</style>
